import { render, staticRenderFns } from "./jy.vue?vue&type=template&id=4c18cdbe&scoped=true&"
import script from "./jy.vue?vue&type=script&lang=js&"
export * from "./jy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c18cdbe",
  null
  
)

export default component.exports